module.exports = __webpack_public_path__ + "static/feature-1-2bc1a03b778a8a87ecb49f67de2f1638.svg";